import { useCssModule, computed } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "./index-CgZzOVq6.js";
import "vue-demi";
import "./index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-VvYS6rEj.js";
function useIconProps() {
  const ICON_STYLES = ["fal", "fas", "fak", "fad", "fab"];
  function createIconProps2({ required = false, style = "fal" } = {
    required: void 0,
    style: void 0
  }) {
    return {
      icon: {
        type: String,
        required
      },
      iconStyle: {
        type: String,
        default: style,
        validator: (iconStyle) => ICON_STYLES.includes(iconStyle)
      }
    };
  }
  return {
    ICON_STYLES,
    createIconProps: createIconProps2
  };
}
const icon = "_icon_10ehf_5";
const isFixedWidth = "_isFixedWidth_10ehf_5";
const left = "_left_10ehf_9";
const right = "_right_10ehf_13";
const style0 = {
  icon,
  isFixedWidth,
  left,
  right
};
const ICON_SIZES = [
  "2xs",
  "xs",
  "sm",
  "lg",
  "xl",
  "2xl",
  "1x",
  "2x",
  "3x",
  "4x",
  "5x",
  "6x",
  "7x",
  "8x",
  "9x",
  "10x"
];
const { createIconProps } = useIconProps();
const __default__ = {
  name: "XIcon",
  components: {
    FontAwesomeIcon
  }
};
const _sfc_main = Object.assign(__default__, {
  props: {
    size: {
      type: String,
      default: null,
      validation: (size) => ICON_SIZES.includes(size)
    },
    rotation: {
      type: String,
      default: null
    },
    flip: {
      type: String,
      default: null
    },
    pull: {
      type: String,
      default: null
    },
    transform: {
      type: String,
      default: null
    },
    fixedWidth: Boolean,
    spin: Boolean,
    pulse: Boolean,
    border: Boolean,
    inverse: Boolean,
    swapOpacity: Boolean,
    left: Boolean,
    right: Boolean,
    ...createIconProps({
      required: true
    })
  },
  setup(__props) {
    const props = __props;
    const $style = useCssModule();
    const iconClasses = computed(() => [
      { [$style.left]: props.left },
      { [$style.right]: props.right }
    ]);
    return { __sfc: true, ICON_SIZES, createIconProps, props, $style, iconClasses, FontAwesomeIcon };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.FontAwesomeIcon, { class: [_setup.iconClasses, _setup.$style.icon, _vm.fixedWidth && _setup.$style.isFixedWidth], attrs: { "icon": [_vm.iconStyle, _vm.icon], "size": _vm.size, "fixed-width": _vm.fixedWidth, "rotation": _vm.rotation, "flip": _vm.flip, "spin": _vm.spin, "pulse": _vm.pulse, "border": _vm.border, "pull": _vm.pull, "inverse": _vm.inverse, "swap-opacity": _vm.swapOpacity, "transform": _vm.transform } });
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XIcon = __component__.exports;
export {
  ICON_SIZES as I,
  XIcon as X,
  useIconProps as u
};
